import PropTypes from 'prop-types';
import { ReactComponent as Age } from '../../assets/icons/age.svg';
import { ReactComponent as Diet } from '../../assets/icons/diet.svg';
import { ReactComponent as Enemy } from '../../assets/icons/enemy.svg';
import { ReactComponent as Friendlyness } from '../../assets/icons/friendlyness.svg';
import { ReactComponent as ScientificName } from '../../assets/icons/scientific_name.svg';
import { ReactComponent as Size } from '../../assets/icons/size.svg';

const QuizQuestionIcon = ({ type }) => {

	const getIcon = () => {
		switch (type) {
			case 'scientificName':
				return <ScientificName />;
			case 'size':
				return <Size />;
			case 'friendlyness':
				return <Friendlyness />;
			case 'age':
				return <Age />;
			case 'enemy':
				return <Enemy />;
			case 'diet':
				return <Diet />;
			default:
				return <></>;
		}
	};

	return <div className="absolute right-4 top-4 cardcolored opacity-30" style={{ zIndex: -1, }}>
		{getIcon()}
	</div>
}

QuizQuestionIcon.propTypes = {
	type: PropTypes.string.isRequired
}

export default QuizQuestionIcon;
